(function(window) {
    var utilityNav = function() {
        var menuStack = [];
        var ui = {};
        var isMobile;
        var SHOW_CSS = '-active';
        var MEDIA_QUERY = '(max-width: 991px)';
        var mql = window.matchMedia(MEDIA_QUERY);

        function cacheUI() {
            ui.$body = $('body');
            ui.$utilityNav = $('[data-regon="desktop-utility-nav"]');
            ui.$dropdown = $('[data-sub-toggle="dropdown"]');
            ui.$toggleText = $('.js-toggle-text');
            ui.$localSelectorDesc = $('.locale-selector__desc');
        }

        function toggleMegaSub(e) {
            e.preventDefault();
            var $target = $(e.target);
            ui.$utilityNav.find('.-active').removeClass('-active');
            $target.closest('li').addClass('-active');
            $('body').on('click', function(event) {
                checkUtilityNavOpen(event);
            });
        }

        function toggleTextHandler(e) {
            e.preventDefault();
            $(ui.$localSelectorDesc).toggleClass('-show');
            $(this).toggleClass('-active');
        }

        function removeActives() {
            ui.$utilityNav.find('.-active').removeClass('-active');
            $('body').off('click', function(event) {
                checkUtilityNavOpen(event);
            });
        }

        function checkUtilityNavOpen(event) {
            if (
                !$(event.target).parents('[data-regon="desktop-utility-nav"]')
                    .length
            ) {
                removeActives();
            }
        }

        function handleMediaQueryChange(mql) {
            removeActives();
        }

        function bindEvents() {
            ui.$dropdown.on('click', toggleMegaSub);
            ui.$toggleText.on('click', toggleTextHandler);
        }

        function init() {
            cacheUI();
            bindEvents();
        }

        return {
            init: init,
        };
    };

    var utilityMenu = utilityNav();
    utilityMenu.init();
})(window);
